import React, { memo, useState } from "react";
import {
  Handle,
  Position,
  NodeResizer,
  useUpdateNodeInternals,
} from "@xyflow/react";

const TPNode = ({ id, data, selected }: any) => {
  const [rotation, setRotation] = useState(data.rotation || 0); // Estado para armazenar o grau de rotação
  const updateNodeInternals = useUpdateNodeInternals();

  // Alternar entre os graus de rotação: 0°, 90°, 180°, 270°
  const toggleRotation = () => {
    const newRotation = (rotation + 90) % 360;
    setRotation(newRotation);
    data.rotation = newRotation; // Salvar no `data`
    updateNodeInternals(id); // Atualizar internamente o nó no React Flow
  };

  // Função para mapear posições com base na rotação
  const getRotatedPosition = (basePosition: Position): Position => {
    const positions = [
      Position.Top,
      Position.Right,
      Position.Bottom,
      Position.Left,
    ];
    const baseIndex = positions.indexOf(basePosition);
    const rotatedIndex = (baseIndex - rotation / 90 + 4) % 4; // Ajuste para considerar a direção correta
    return positions[rotatedIndex];
  };

  return (
    <div
      style={{
        position: "relative",
        width: data.width || "60px", // Define o tamanho do contêiner como o tamanho do SVG
        height: data.height || "60px", // Mesmo tamanho do SVG
        background: "transparent",
        transform: `rotate(${rotation}deg)`,
        transformOrigin: "center",
      }}
      onClick={toggleRotation}
    >
      {/* NodeResizer para tornar o nó redimensionável */}
      <NodeResizer
        color="#0077ff"
        isVisible={selected}
        minWidth={60}
        minHeight={60}
        keepAspectRatio={true}
        onResize={(event, size) => {
          data.width = `${size.width}px`;
          data.height = `${size.height}px`;
        }}
      />

      {/* Handles ajustados com base na rotação */}
      <Handle
        type="source"
        position={getRotatedPosition(Position.Left)}
        isConnectable
        id="left"
      />
      <Handle
        type="target"
        position={getRotatedPosition(Position.Left)}
        isConnectable
        id="left"
      />
      <Handle
        type="source"
        position={getRotatedPosition(Position.Right)}
        isConnectable
        id="right"
      />
      <Handle
        type="target"
        position={getRotatedPosition(Position.Right)}
        isConnectable
        id="right"
      />
      <Handle
        type="source"
        position={getRotatedPosition(Position.Top)}
        isConnectable
        id="top"
      />
      <Handle
        type="target"
        position={getRotatedPosition(Position.Top)}
        isConnectable
        id="top"
      />
      <Handle
        type="source"
        position={getRotatedPosition(Position.Bottom)}
        isConnectable
        id="bottom"
      />
      <Handle
        type="target"
        position={getRotatedPosition(Position.Bottom)}
        isConnectable
        id="bottom"
      />

      {/* SVG para o nó */}
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 60 60" // Tamanho exato do SVG
        xmlns="http://www.w3.org/2000/svg"
        style={{
          display: "block",
          pointerEvents: "none",
        }}
      >
        <circle cx="20" cy="30" r="15" fill="#7d7d7d" opacity="0.8" />
        <circle cx="40" cy="30" r="15" fill="#7d7d7d" opacity="0.8" />
      </svg>
    </div>
  );
};

export default memo(TPNode);
